import { showLegacyIM } from "lme/dsp/LegacyInternetModule";

export default function DriverChoice() {
  showLegacyIM("My Matched Loads", "/apps/vaadindriverchoice", "yes");
}
